export const DJ_LEVEL = {
  MAX: 9,
  AAA: 8,
  AA: 7,
  A: 6,
  B: 5,
  C: 4,
  D: 3,
  E: 2,
  F: 1,
  NO_SCORE: 0,
} as const;

export type DjLevel = (typeof DJ_LEVEL)[keyof typeof DJ_LEVEL];

export const DJ_LEVEL_STRING = {
  9: "MAX",
  8: "AAA",
  7: "AA",
  6: "A",
  5: "B",
  4: "C",
  3: "D",
  2: "E",
  1: "F",
  0: "NO SCORE",
} as const;

export const DJ_LEVEL_COLOR = {
  9: "#FF22FFA0",
  8: "#FF0000A0",
  7: "#FF8C00A0",
  6: "#00FFFFA0",
  5: "#00FF00A0",
  4: "#33FF33A0",
  3: "#66FF66A0",
  2: "#99FF99A0",
  1: "#CCFFCCA0",
  0: "#FFFFFFA0",
} as const;

export const isDjLevel = (n: unknown): n is DjLevel => {
  return typeof n === "number" && Object.values<typeof n>(DJ_LEVEL).includes(n);
};
